<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help Text"
      [formField]="configForm.helpText" />
    <lib-signal-number-field
      label="Maximum File Size"
      [formField]="configForm.maxFileSize" />
    <lib-signal-number-field
      label="Maximum Number of Images"
      [formField]="configForm.maxImages" />
    <lib-signal-checkbox
      label="Required"
      [formField]="configForm.required" />
  </section>
</form>
